const collaborationHasVisitedLocalStorage = 'scheduler-collaboration-has-visited';

const defaultValue = false;

export const getCollaborationHasVisitedLocalStorage = () => {
    const valueLocalStorage = localStorage.getItem(collaborationHasVisitedLocalStorage);
    return valueLocalStorage ? Boolean(Number(valueLocalStorage)) : defaultValue;
};
export const setCollaborationHasVisitedLocalStorage = (hasVisited: boolean) => {
    if (hasVisited === defaultValue) {
        localStorage.removeItem(collaborationHasVisitedLocalStorage);
        return;
    }
    localStorage.setItem(collaborationHasVisitedLocalStorage, JSON.stringify(Number(hasVisited)));
};
